import './Select.css';
import React from 'react';
import { FieldError, FieldErrors, get } from 'react-hook-form';
import InputWrapper from '#sign-up/components/shared/InputWrapper';
import { errorFormatter } from '#sign-up/components/shared/InputWrapperUtil';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  errors?: FieldErrors;
  options?: { Text: string; Value: string }[];
  placeholder?: string;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      label = '',
      required = false,
      name,
      errors,
      onChange,
      options = [],
      disabled = false,
      className,
      placeholder,
      style,
      ...props
    }: SelectProps,
    ref
  ) => {
    const error = get(errors, name) as FieldError;

    return (
      <InputWrapper
        fieldType="select-field"
        label={label}
        name={name || ''}
        className={className}
        style={style}
        error={error}
      >
        <select
          id={name}
          ref={ref}
          name={name}
          onChange={onChange}
          aria-describedby={errorFormatter(name || '', error)}
          disabled={disabled}
          required={required}
          className={className}
          {...props}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {options?.map((item) => (
            <option key={item.Value} value={item.Value}>
              {item.Text}
            </option>
          ))}
        </select>
      </InputWrapper>
    );
  }
);

Select.displayName = 'Select';

export default Select;
